exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".importantinfo-tickbox .form-checkbox-label{padding-top:0}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/Plans/BringYourOwnModem/ImportantInfoTickbox.scss
 ** module id = 1208
 ** module chunks = 0
 **/